/* eslint-disable id-length */
import Api from '@/api'
import Env from '@/modules/env'

const abtest = {

    mobilePopUP: function () {
        const url = Env.isProd() ? 'https://ab-ml.cleanfox.io' : 'https://ab-ml.cleanfoxv3.sandbox.internal.foxapi.xyz'

        return Api.abtesting.call(url)
    },

    landingv4: function () {
        const url = Env.isProd() ? 'https://ab-ml-10.cleanfox.io' : 'https://ab-ml-10.cleanfoxv3.sandbox.internal.foxapi.xyz'

        return Api.abtesting.call(url)
    }
}

export default abtest
